import { useMemo } from 'react'
import { Dialog, Box, Text, Table, useResponsiveValue } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'

type Props = {
  visible: boolean
  closeModal: () => void
}

const ListingTypeModal = ({ visible, closeModal }: Props) => {
  const { t } = useTranslation()
  const isMobile = useResponsiveValue()({
    mobile: true,
    tablet: false
  })

  const data = [
    {
      type: t('Single listing', 'Single listing'),
      description: t(
        'l.listing.edit.single_listing_type.text',
        'Create a listing for a single rental unit.'
      )
    },
    {
      type: t('Multi-unit listing', 'Multi-unit listing'),
      description: t(
        'l.listing.edit.multiunit_listing_type.text',
        'Create a listing for multiple rental units in the same building.'
      )
    }
  ]

  const columns = useMemo(
    () => [
      {
        Header: t('Type', 'Type'),
        accessor: 'type',
        gridWidth: { custom: '150px' },
        disableSortBy: true,
        Cell: (cell: { value: string; row: { original: any } }) => {
          return (
            <Box paddingY="small">
              <Text>{cell?.value}</Text>
            </Box>
          )
        }
      },
      {
        Header: t('Description', 'Description'),
        accessor: 'description',
        gridWidth: { custom: 'auto' },
        disableSortBy: true,
        Cell: (cell: { value: string; row: { original: any } }) => {
          return <Text>{cell?.value}</Text>
        }
      }
    ],
    [t]
  )

  const mobileColumns = useMemo(
    () => [
      {
        Header: t('Description', 'Description'),
        accessor: 'description',
        gridWidth: { custom: '100%' },
        disableSortBy: true,
        Cell: (cell: { value: string; row: { original: any } }) => {
          return (
            <Box paddingY="xsmall" display="flex" flexDirection="column" gap="medium">
              <Text weight="strong">{cell?.row?.original?.type}</Text>
              <Text>{cell?.value}</Text>
            </Box>
          )
        }
      }
    ],
    [t]
  )

  return (
    <Dialog
      width="small"
      id="listing-type-dialog"
      open={visible}
      onClose={closeModal}
      title={t('Listing Type', 'Listing Type')}
    >
      <Table
        data={data}
        columns={isMobile ? mobileColumns : columns}
        width="full"
        itemsSelectedText=""
        clearAllText=""
      />
    </Dialog>
  )
}

export default ListingTypeModal
